import { render, staticRenderFns } from "./vpn.vue?vue&type=template&id=c947ba4c&"
import script from "./vpn.vue?vue&type=script&lang=js&"
export * from "./vpn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports